import React, { useState } from 'react'

import { CreateToolbar, CreateForm } from './containers'

export const CreateStuffLinker = (props: any) => {
  const {
    shouldRedirect = true,
    closeDrawer = false,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
  } = props

  const [formData, setFormData] = useState([])

  return (
    <>
      <CreateForm
        {...props}
        setFormData={setFormData}
        toolbar={<CreateToolbar closeDrawer={closeDrawer} />}
        onSubmitSuccess={onSubmitSuccess}
        onSubmitFailure={onSubmitFailure}
        shouldRedirect={shouldRedirect}
        resource="cms/content/linker"
      />
    </>
  )
}
